export type WhatsAppClickSource = "hero_button" | "floating_bubble";

type AnalyticsWindow = typeof window & {
  gtag?: (...args: unknown[]) => void;
  fbq?: (...args: unknown[]) => void;
};

/**
 * Track a WhatsApp button click on GA4 and Meta Pixel.
 * Safe to call from any component — no-ops on SSR or if scripts are blocked.
 */
export function trackWhatsAppClick(source: WhatsAppClickSource) {
  if (typeof window === "undefined") return;
  const w = window as AnalyticsWindow;

  try {
    if (typeof w.gtag === "function") {
      w.gtag("event", "whatsapp_click", { source, location: "landing" });
    }
  } catch {
    // ignore
  }

  try {
    if (typeof w.fbq === "function") {
      w.fbq("trackCustom", "WhatsAppClick", { source });
    }
  } catch {
    // ignore
  }
}
